(function () {
  'use strict';

  var LOADING_CLASS = 'lop-plp-nav-bar--loading';
  var historyBound = false;
  var sectionHtmlCache = new Map();
  var prefetchInFlight = new Map();

  function getProductGridSectionId() {
    var grid = document.getElementById('product-grid');
    return grid && grid.dataset.id ? grid.dataset.id : null;
  }

  function getProductGridSectionEl() {
    var sectionId = getProductGridSectionId();
    return sectionId ? document.getElementById('shopify-section-' + sectionId) : null;
  }

  function getBreadcrumbsSectionEl() {
    return document.querySelector('.shopify-section.breadcrumbs-section');
  }

  function getBreadcrumbsSectionId() {
    var el = getBreadcrumbsSectionEl();
    if (!el || !el.id) return null;
    var match = el.id.match(/^shopify-section-(.+)$/);
    return match ? match[1] : null;
  }

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url.split('?')[0];
    }
  }

  function setActiveLink(navBar, activeLink) {
    navBar.querySelectorAll('.lop-plp-nav-bar__link').forEach(function (link) {
      link.classList.remove('lop-plp-nav-bar__link--active');
      link.removeAttribute('aria-current');
    });
    activeLink.classList.add('lop-plp-nav-bar__link--active');
    activeLink.setAttribute('aria-current', 'page');
  }

  function findNavLinkForUrl(navBar, url) {
    var targetPath = normalizePath(url);
    var links = navBar.querySelectorAll('.lop-plp-nav-bar__link');
    for (var i = 0; i < links.length; i++) {
      if (normalizePath(links[i].href) === targetPath) {
        return links[i];
      }
    }
    return null;
  }

  function showGridLoading() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var collection = container.querySelector('.collection');
    if (collection) collection.classList.add('loading');
  }

  function hideGridLoading() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var collection = container.querySelector('.collection');
    if (collection) collection.classList.remove('loading');
  }

  function loadImageImmediately(img, highPriority) {
    if (!img || img.classList.contains('lazyloaded')) return;

    var srcset = img.getAttribute('data-srcset');
    if (srcset) {
      img.srcset = srcset;
      img.sizes = img.getAttribute('data-sizes') || 'auto';

      var parts = srcset.split(',');
      var chosen = null;
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf('375w') !== -1) {
          chosen = parts[i].trim().split(/\s+/)[0];
          break;
        }
      }
      if (!chosen && parts.length) {
        chosen = parts[0].trim().split(/\s+/)[0];
      }
      if (chosen) {
        img.src = chosen;
      }
    } else {
      var dataSrc = img.getAttribute('data-src');
      if (dataSrc) {
        img.src = dataSrc;
      }
    }

    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('lazyloaded');
    img.loading = 'eager';
    if (highPriority && 'fetchPriority' in img) {
      img.fetchPriority = 'high';
    }

    if (typeof img.decode === 'function') {
      img.decode().catch(function () {});
    }
  }

  function loadImageFromUrl(img, url) {
    if (!img || !url || img.classList.contains('lazyloaded')) return;

    var normalized = url.replace(/width=\d+/, 'width=375');
    var srcset = normalized + ' 375w, ' + url + ' 770w';
    img.srcset = srcset;
    img.sizes = img.getAttribute('data-sizes') || 'auto';
    img.src = normalized;
    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('lazyloaded');
    img.loading = 'lazy';

    if (typeof img.decode === 'function') {
      img.decode().catch(function () {});
    }
  }

  function loadProductGridImages(root) {
    if (!root) return;

    var primaryImages = root.querySelectorAll('.product-primary-image.lazyload');
    primaryImages.forEach(function (img, index) {
      loadImageImmediately(img, index < 8);
    });

    if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
      root.querySelectorAll('.lazyload:not(.product-primary-image)').forEach(function (img) {
        lazySizes.loader.unveil(img);
      });
    }
  }

  function bindCarouselImageLoading(root) {
    if (!root || root.getAttribute('data-lop-carousel-bound') === '1') return;
    root.setAttribute('data-lop-carousel-bound', '1');

    root.addEventListener('click', function (event) {
      var button = event.target.closest('.product-card-nav-next, .product-card-nav-prev');
      if (!button) return;

      var card = button.closest('product-card');
      if (!card) return;

      window.requestAnimationFrame(function () {
        var urls = (card.getAttribute('data-product-images') || '').split('||').filter(Boolean);
        var carouselImgs = card.querySelectorAll('.product-card-carousel-image');
        var activeImg = card.querySelector('.product-card-carousel-image.active') || carouselImgs[0];

        if (!activeImg || activeImg.classList.contains('lazyloaded')) return;

        var index = Array.prototype.indexOf.call(carouselImgs, activeImg);
        if (index >= 0 && urls[index]) {
          loadImageFromUrl(activeImg, urls[index]);
          return;
        }

        loadImageImmediately(activeImg, false);
      });
    });
  }

  function restoreScrollPosition(x, y) {
    window.scrollTo(x, y);
    window.requestAnimationFrame(function () {
      window.scrollTo(x, y);
    });
  }

  function resetFacetState() {
    if (typeof FacetFiltersForm === 'undefined') return;
    FacetFiltersForm.searchParamsInitial = '';
    FacetFiltersForm.searchParamsPrev = '';
    FacetFiltersForm.filterData = [];
  }

  function updateDocumentTitle(html, linkEl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var title = doc.querySelector('title');
    if (title && title.textContent) {
      document.title = title.textContent;
      return;
    }
    if (!linkEl) return;
    var suffix = document.title.indexOf('|') > -1 ? document.title.slice(document.title.indexOf('|')) : '';
    document.title = linkEl.textContent.trim() + (suffix ? ' ' + suffix : '');
  }

  function getSectionDomId(sectionEl) {
    if (!sectionEl || !sectionEl.id) return null;
    var match = sectionEl.id.match(/^shopify-section-(.+)$/);
    return match ? match[1] : null;
  }

  function isHeroStopSection(sectionEl) {
    if (!sectionEl || !sectionEl.classList.contains('shopify-section')) return false;
    if (sectionEl.classList.contains('section-lop-plp-nav-bar')) return true;
    if (sectionEl.querySelector('#product-grid')) return true;
    return false;
  }

  function getHeroInsertBeforeEl() {
    return (
      document.querySelector('.shopify-section.section-lop-plp-nav-bar') ||
      getProductGridSectionEl()
    );
  }

  function getHeroSectionsFromDocument(root) {
    var doc = root || document;
    var breadcrumbs = doc.querySelector('.shopify-section.breadcrumbs-section');
    if (!breadcrumbs) return [];

    var heroes = [];
    var el = breadcrumbs.nextElementSibling;

    while (el) {
      if (el.nodeType !== 1) {
        el = el.nextElementSibling;
        continue;
      }
      if (!el.classList.contains('shopify-section')) {
        el = el.nextElementSibling;
        continue;
      }
      if (isHeroStopSection(el)) break;
      heroes.push(el);
      el = el.nextElementSibling;
    }

    return heroes;
  }

  function sectionHasBannerHero(sectionEl) {
    if (!sectionEl) return false;
    if (sectionEl.querySelector('slide-show.main-slideshow, slide-show.slideshow')) return true;
    if (sectionEl.querySelector('.columbia-lop-better-thant-banner-section, .columbia-lop-better-thant-banner-image')) return true;
    if (sectionEl.querySelector('.columbia-banner-collection, .columbia-banner')) return true;
    return false;
  }

  function destinationHasBannerHero(sourceDoc) {
    var heroes = getHeroSectionsFromDocument(sourceDoc);
    for (var i = 0; i < heroes.length; i++) {
      if (sectionHasBannerHero(heroes[i])) return true;
    }
    return false;
  }

  function setNavBarSectionVisible(visible) {
    var section = document.querySelector('.shopify-section.section-lop-plp-nav-bar');
    if (!section) return;
    section.classList.toggle('lop-plp-nav-bar-section--hidden', !visible);
  }

  function initHeroSections(heroSections) {
    if (!heroSections || !heroSections.length) return;

    heroSections.forEach(function (sectionEl) {
      sectionEl.querySelectorAll('.lazyload').forEach(function (img) {
        if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
          lazySizes.loader.unveil(img);
        }
      });

      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: getSectionDomId(sectionEl) }
        })
      );
    });

    window.dispatchEvent(new Event('resize'));
  }

  function syncHeroSectionsFromDoc(sourceDoc) {
    var insertBefore = getHeroInsertBeforeEl();
    if (!insertBefore) return;

    var destHeroes = getHeroSectionsFromDocument(sourceDoc);
    var currentHeroes = getHeroSectionsFromDocument(document);

    currentHeroes.forEach(function (sectionEl) {
      sectionEl.remove();
    });

    destHeroes.forEach(function (destSection) {
      insertBefore.insertAdjacentHTML('beforebegin', destSection.outerHTML);
    });

    initHeroSections(getHeroSectionsFromDocument(document));
  }

  async function fetchCollectionPageHtml(collectionUrl) {
    var path = normalizePath(collectionUrl);
    var cacheKey = getSectionCacheKey(path, '__page__');

    if (sectionHtmlCache.has(cacheKey)) {
      return sectionHtmlCache.get(cacheKey);
    }

    var response = await fetch(path);
    if (!response.ok) throw new Error('Page fetch failed: ' + path);
    var html = await response.text();
    cacheSectionHtml(path, '__page__', html);
    return html;
  }

  function replaceShopifySection(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newSection =
      doc.getElementById('shopify-section-' + sectionId) ||
      doc.querySelector('.shopify-section');
    var currentSection = document.getElementById('shopify-section-' + sectionId);
    if (!newSection || !currentSection) return false;
    currentSection.innerHTML = newSection.innerHTML;
    return true;
  }

  function updateSidebarResultsClass(doc) {
    var newSidebar = doc.getElementById('Sidebar-Container');
    var currentSidebar = document.getElementById('Sidebar-Container');
    if (!newSidebar || !currentSidebar) return;

    Array.from(currentSidebar.classList).forEach(function (className) {
      if (className.indexOf('results--') === 0) {
        currentSidebar.classList.remove(className);
      }
    });

    Array.from(newSidebar.classList).forEach(function (className) {
      if (className.indexOf('results--') === 0) {
        currentSidebar.classList.add(className);
      }
    });
  }

  function resetFacetPanels() {
    document.body.classList.remove('open-cc');

    var drawer = document.getElementById('Facet-Drawer');
    if (drawer) {
      drawer.classList.remove('active');
      drawer.setAttribute('inert', '');
    }

    var sidebar = document.getElementById('Sidebar-Container');
    if (sidebar) {
      sidebar.classList.remove('facets--sidebar-open');
    }

    document.querySelectorAll('sidebar-toggle span').forEach(function (span) {
      if (typeof theme !== 'undefined' && theme.strings && theme.strings.showFilters) {
        span.textContent = theme.strings.showFilters;
      }
    });
  }

  function replaceElementInnerHtml(selector, doc) {
    var newEl = doc.querySelector(selector);
    var currentEl = document.querySelector(selector);
    if (newEl && currentEl) {
      currentEl.innerHTML = newEl.innerHTML;
      return true;
    }
    return false;
  }

  function replaceCustomElement(selector, doc) {
    var newEl = doc.querySelector(selector);
    var currentEl = document.querySelector(selector);
    if (newEl && currentEl && currentEl.parentNode) {
      currentEl.outerHTML = newEl.outerHTML;
      return true;
    }
    return false;
  }

  function deferSecondaryCarouselImages(doc) {
    doc.querySelectorAll('.product-card-carousel-image:not(.product-primary-image)').forEach(function (img) {
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.classList.remove('lazyload', 'lazyloading');
    });
  }

  function updateCollectionGridFromSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    resetFacetPanels();
    deferSecondaryCarouselImages(doc);

    if (!replaceElementInnerHtml('.sidebar-container--products', doc)) {
      return false;
    }

    replaceElementInnerHtml('.facets-desktop-container', doc);
    replaceElementInnerHtml('#Facet-Drawer .side-panel-content', doc);
    replaceCustomElement('facet-filters-form.facets--bar', doc);
    updateSidebarResultsClass(doc);

    return true;
  }

  function getSectionCacheKey(path, sectionId) {
    return path + '::' + sectionId;
  }

  function cacheSectionHtml(path, sectionId, html) {
    var key = getSectionCacheKey(path, sectionId);
    sectionHtmlCache.set(key, html);
    if (sectionHtmlCache.size > 6) {
      var firstKey = sectionHtmlCache.keys().next().value;
      sectionHtmlCache.delete(firstKey);
    }
  }

  function prefetchCollection(url) {
    var path = normalizePath(url);
    var productGridSectionId = getProductGridSectionId();
    if (!productGridSectionId) return;

    var cacheKey = getSectionCacheKey(path, productGridSectionId);
    if (sectionHtmlCache.has(cacheKey) || prefetchInFlight.has(cacheKey)) {
      return;
    }

    var fetchUrl = path + '?section_id=' + encodeURIComponent(productGridSectionId);
    var request = fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Prefetch failed');
        return response.text();
      })
      .then(function (html) {
        cacheSectionHtml(path, productGridSectionId, html);
      })
      .catch(function () {})
      .finally(function () {
        prefetchInFlight.delete(cacheKey);
      });

    prefetchInFlight.set(cacheKey, request);
  }

  async function fetchSectionHtml(collectionUrl, sectionId) {
    var path = normalizePath(collectionUrl);
    var cacheKey = getSectionCacheKey(path, sectionId);
    var fetchUrl = path + '?section_id=' + encodeURIComponent(sectionId);

    if (sectionHtmlCache.has(cacheKey)) {
      return sectionHtmlCache.get(cacheKey);
    }

    var pending = prefetchInFlight.get(cacheKey);
    if (pending) {
      await pending;
      if (sectionHtmlCache.has(cacheKey)) {
        return sectionHtmlCache.get(cacheKey);
      }
    }

    var response = await fetch(fetchUrl);
    if (!response.ok) throw new Error('Section fetch failed: ' + sectionId);
    var html = await response.text();
    cacheSectionHtml(path, sectionId, html);
    return html;
  }

  async function navigateToCollection(url, activeLink, navBar, updateHistory) {
    if (updateHistory === undefined) updateHistory = true;
    if (navBar.classList.contains(LOADING_CLASS)) return;

    var productGridSectionId = getProductGridSectionId();
    if (!productGridSectionId || !getProductGridSectionEl()) {
      window.location.href = url;
      return;
    }

    navBar.classList.add(LOADING_CLASS);
    showGridLoading();

    var savedScrollX = window.pageXOffset;
    var savedScrollY = window.pageYOffset;

    try {
      var breadcrumbsSectionId = getBreadcrumbsSectionId();
      var pageFetch = fetchCollectionPageHtml(url);
      var gridFetch = fetchSectionHtml(url, productGridSectionId);
      var breadcrumbsFetch = breadcrumbsSectionId
        ? fetchSectionHtml(url, breadcrumbsSectionId).catch(function (breadcrumbError) {
            console.warn('LOP PLP nav bar: breadcrumbs update skipped', breadcrumbError);
            return null;
          })
        : Promise.resolve(null);

      var gridHtml = await gridFetch;
      var pageHtml = await pageFetch;
      var pageDoc = new DOMParser().parseFromString(pageHtml, 'text/html');

      syncHeroSectionsFromDoc(pageDoc);
      setNavBarSectionVisible(!destinationHasBannerHero(pageDoc));

      if (!updateCollectionGridFromSectionHtml(gridHtml)) {
        throw new Error('Product grid section not found');
      }

      loadProductGridImages(document.querySelector('.sidebar-container--products'));
      bindCarouselImageLoading(document.querySelector('.sidebar-container--products'));

      var breadcrumbsHtml = await breadcrumbsFetch;
      if (breadcrumbsHtml && breadcrumbsSectionId) {
        replaceShopifySection(breadcrumbsHtml, breadcrumbsSectionId);
      }

      updateDocumentTitle(gridHtml, activeLink);
      setActiveLink(navBar, activeLink);
      resetFacetState();

      if (updateHistory && window.history && window.history.pushState) {
        window.history.pushState(
          { lopPlpNavBar: true, url: normalizePath(url) },
          '',
          url
        );
      }

      restoreScrollPosition(savedScrollX, savedScrollY);

      document.dispatchEvent(
        new CustomEvent('lop-plp-nav-bar:changed', {
          bubbles: true,
          detail: { url: url }
        })
      );
    } catch (error) {
      console.error('LOP PLP nav bar:', error);
      window.location.href = url;
    } finally {
      navBar.classList.remove(LOADING_CLASS);
      hideGridLoading();
      restoreScrollPosition(savedScrollX, savedScrollY);
    }
  }

  function onLinkClick(event) {
    var link = event.currentTarget;
    if (link.classList.contains('lop-plp-nav-bar__link--active')) return;

    var navBar = link.closest('.lop-plp-nav-bar');
    if (!navBar) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') {
      return;
    }

    event.preventDefault();
    navigateToCollection(link.href, link, navBar, true);
  }

  function onPopState(event) {
    if (event.state && event.state.searchParams !== undefined && !event.state.lopPlpNavBar) return;

    var navBar = document.querySelector('.lop-plp-nav-bar');
    if (!navBar) return;

    var activeLink = findNavLinkForUrl(navBar, window.location.href);
    if (activeLink && !window.location.search) {
      navigateToCollection(window.location.href, activeLink, navBar, false);
      return;
    }

    window.location.reload();
  }

  function bindNavBar(navBar) {
    if (navBar.getAttribute('data-lop-nav-bound') === '1') return;
    navBar.setAttribute('data-lop-nav-bound', '1');

    navBar.querySelectorAll('.lop-plp-nav-bar__link').forEach(function (link) {
      var prefetchTimer = null;

      link.addEventListener('click', onLinkClick);

      link.addEventListener('mouseenter', function () {
        prefetchTimer = window.setTimeout(function () {
          prefetchCollection(link.href);
        }, 80);
      });

      link.addEventListener('mouseleave', function () {
        if (prefetchTimer) {
          window.clearTimeout(prefetchTimer);
          prefetchTimer = null;
        }
      });

      link.addEventListener('focus', function () {
        prefetchCollection(link.href);
      });

      link.addEventListener('touchstart', function () {
        prefetchCollection(link.href);
      }, { passive: true });
    });
  }

  function init() {
    document.querySelectorAll('.lop-plp-nav-bar').forEach(bindNavBar);

    if (!historyBound) {
      historyBound = true;
      window.addEventListener('popstate', onPopState);
    }
  }

  init();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
